import {useMutation, useQueryClient} from "@tanstack/react-query";
import {message} from "antd";
import {AxiosError} from "axios";
import {useClientV2} from "../../../../utils/hooks";
import {
  CUSTOMER_PURCHASED_SUBSCRIPTIONS_RQ_KEY,
  GET_CUSTOMER_PURCHASED_SUBSCRIPTION_RQ_KEY,
} from "../constants";

function formatCancelError(error: unknown) {
  if (error && typeof error === "object" && "message" in error) {
    return String((error as {message: unknown}).message);
  }
  return "Could not cancel subscription.";
}

export const useCancelCustomerSubscriptionApi = () => {
  const queryClient = useQueryClient();
  const client = useClientV2();

  return useMutation<unknown, AxiosError<{message: string}>, {subscriptionId: number}>({
    mutationFn: async ({subscriptionId}) => {
      return client(`customer/subscriptions/${subscriptionId}/cancel`, {
        method: "PATCH",
        data: {},
      });
    },
    onError: (error: unknown) => {
      message.error(formatCancelError(error));
    },
    onSuccess: () => {
      message.success("Subscription cancelled.");
    },
    onSettled: (_, __, {subscriptionId}) => {
      queryClient.invalidateQueries({
        queryKey: [CUSTOMER_PURCHASED_SUBSCRIPTIONS_RQ_KEY],
      });
      queryClient.invalidateQueries({
        queryKey: [GET_CUSTOMER_PURCHASED_SUBSCRIPTION_RQ_KEY, String(subscriptionId)],
      });
    },
  });
};
